var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEntryMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H18.75V4.49933L21 4.49895V19.5001H18.75V21.0001H21C21.8272 21.0001 22.5 20.3273 22.5 19.5001V4.5C22.5 3.67275 21.8272 3 21 3Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25C12.8284 14.25 13.5 13.5784 13.5 12.75C13.5 11.9216 12.8284 11.25 12 11.25C11.1716 11.25 10.5 11.9216 10.5 12.75C10.5 13.5784 11.1716 14.25 12 14.25Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3V21C16.5 21.8272 15.8273 22.5 15 22.5H3C2.17275 22.5 1.5 21.8272 1.5 21V3C1.5 2.17275 2.17275 1.5 3 1.5H15C15.8273 1.5 16.5 2.17275 16.5 3ZM3 21H15V2.99888L3 3V21Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEntryMethod);
export default __webpack_public_path__ + "static/media/ic-entry-method.c70860e0e81144313f6188b871bd6213.svg";
export { ForwardRef as ReactComponent };